  document.addEventListener('DOMContentLoaded', function() {
  const track = document.querySelector('[data-column-track]');
  const prevButton = document.querySelector('[data-column-prev]');
  const nextButton = document.querySelector('[data-column-next]');
  const slides = document.querySelectorAll('.column-list__slide');
  const slider = document.querySelector('.column-list__slider');
  const links = document.querySelectorAll('[data-column-link]');
  
  if (!track || slides.length === 0) return;
  
  const gap = parseInt('{{ section.settings.grid_horizontal }}') || 0;
  let currentPosition = 0;
  let isDragging = false;
  let startPosition = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let animationID;
  let currentIndex = 0;
  let startTime = 0;
  let startX = 0;
  let startY = 0;
  const TAP_THRESHOLD = 5;
  const SWIPE_THRESHOLD = 10;

  function getSlideWidth() {
    if (slides.length === 0) return 0;
    const slide = slides[0];
    return slide.offsetWidth + gap;
  }

  function getMaxPosition() {
    const slideWidth = getSlideWidth();
    const trackWidth = track.scrollWidth;
    const containerWidth = slider.offsetWidth;
    return Math.max(0, trackWidth - containerWidth);
  }

  function updateSlider() {
    const maxPosition = getMaxPosition();
    currentPosition = Math.max(Math.min(currentPosition, 0), -maxPosition);
    track.style.transform = `translateX(${currentPosition}px)`;
    updateArrows();
  }

  function updateArrows() {
    const maxPosition = getMaxPosition();
    if (prevButton) {
      prevButton.disabled = currentPosition >= 0;
    }
    if (nextButton) {
      nextButton.disabled = currentPosition <= -maxPosition || maxPosition <= 0;
    }
  }

  function nextSlide() {
    const slideWidth = getSlideWidth();
    const maxPosition = getMaxPosition();
    currentPosition = Math.max(currentPosition - slideWidth, -maxPosition);
    updateSlider();
  }

  function prevSlide() {
    const slideWidth = getSlideWidth();
    currentPosition = Math.min(currentPosition + slideWidth, 0);
    updateSlider();
  }

  function getPositionX(event) {
    return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
  }

  function getPositionY(event) {
    return event.type.includes('mouse') ? event.pageY : event.touches[0].clientY;
  }

  function touchStart(event) {
    if (event.cancelable) {
      event.preventDefault();
    }
    startTime = Date.now();
    startX = getPositionX(event);
    startY = getPositionY(event);
    isDragging = false;
    prevTranslate = currentPosition;
    currentTranslate = currentPosition;
    track.style.transition = 'none';
    track.style.cursor = 'grabbing';
    
    cancelAnimationFrame(animationID);
  }

  function touchMove(event) {
    if (!isDragging) {
      const currentX = getPositionX(event);
      const currentY = getPositionY(event);
      const deltaX = Math.abs(currentX - startX);
      const deltaY = Math.abs(currentY - startY);
      
      if (deltaX > SWIPE_THRESHOLD && deltaX > deltaY) {
        isDragging = true;
      } else if (deltaY > SWIPE_THRESHOLD) {
        return;
      }
    }
    
    if (!isDragging) return;
    
    if (event.cancelable) {
      event.preventDefault();
    }
    
    const currentPositionX = getPositionX(event);
    const diff = currentPositionX - startX;
    currentTranslate = prevTranslate + diff;
    
    track.style.transform = `translateX(${currentTranslate}px)`;
  }

  function touchEnd(event) {
    if (!isDragging) {
      const endX = getPositionX(event);
      const endY = getPositionY(event);
      const deltaX = Math.abs(endX - startX);
      const deltaY = Math.abs(endY - startY);
      
      if (deltaX < TAP_THRESHOLD && deltaY < TAP_THRESHOLD) {
        const target = event.target;
        const link = target.closest('[data-column-link]');
        
        if (link) {
          window.location.href = link.href;
          return;
        }
      }
      return;
    }
    
    isDragging = false;
    track.style.cursor = 'grab';
    track.style.transition = 'transform 0.3s ease';
    
    const endTime = Date.now();
    const timeDiff = endTime - startTime;
    const moveDiff = currentTranslate - prevTranslate;
    
    const slideWidth = getSlideWidth();
    const velocity = moveDiff / timeDiff;
    
    if (Math.abs(moveDiff) > 30 || Math.abs(velocity) > 0.3) {
      if (moveDiff < 0 || velocity < -0.3) {
        nextSlide();
      } else {
        prevSlide();
      }
    } else {
      updateSlider();
    }
  }

  function handleMouseDown(event) {
    if (event.button !== 0) return;
    touchStart(event);
    
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('mouseleave', handleMouseUp);
  }

  function handleMouseMove(event) {
    touchMove(event);
  }

  function handleMouseUp(event) {
    touchEnd(event);
    
    document.removeEventListener('mousemove', handleMouseMove);
    document.removeEventListener('mouseup', handleMouseUp);
    document.removeEventListener('mouseleave', handleMouseUp);
  }

  function handleLinkClick(event) {
    if (isDragging) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  links.forEach(link => {
    link.addEventListener('click', handleLinkClick, true);
    link.addEventListener('touchend', handleLinkClick, true);
  });

  if (nextButton) nextButton.addEventListener('click', nextSlide);
  if (prevButton) prevButton.addEventListener('click', prevSlide);

  track.addEventListener('touchstart', touchStart, { passive: false });
  track.addEventListener('touchmove', touchMove, { passive: false });
  track.addEventListener('touchend', touchEnd);

  track.addEventListener('mousedown', handleMouseDown);

  track.addEventListener('dragstart', (e) => {
    e.preventDefault();
  });

  window.addEventListener('resize', function() {
    currentPosition = 0;
    updateSlider();
  });

  updateArrows();
});